import React from 'react'
import KunAgueroComp from '../../components/sponsorships/KunAguero'

const KunAguero = () => {
  return (
    <KunAgueroComp/>
  )
}

export default KunAguero